import React from "react";

const TelegramIcon = ({
  size = 26,
  className,
  style = {},
  circle = true
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 240 240"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      {circle && <circle cx="120" cy="120" r="120" fill="#2AABEE" />}
      <path
        fill="#FFFFFF"
        d="M54.3 116.8c35-15.2 58.4-25.3 70.2-30.2 33.4-13.9 40.3-16.3 44.8-16.4 1 0 3.2.2 4.7 1.4 1.2 1 1.6 2.4 1.8 3.4.2 1 .4 3.3.2 5.1-2.2 23.1-11.7 79.2-16.5 105.1-2 11-6 14.7-9.8 15.1-8.3.8-14.6-5.5-22.7-10.8-12.6-8.3-19.8-13.5-32.1-21.6-14.1-9.3-5-14.4 3.1-22.8 2.1-2.2 39.1-35.8 39.8-38.9.1-.4.2-1.9-.7-2.7-.9-.8-2.2-.5-3.1-.3-1.3.3-22.6 14.3-63.8 42-6 4.1-11.5 6.2-16.4 6.1-5.4-.1-15.8-3.1-23.6-5.6-9.5-3.1-17.1-4.7-16.4-9.9.4-2.7 4.5-5.5 12.5-8.8Z"
      />
    </svg>
  );
};

export default TelegramIcon;
